import React, { FC, useCallback, memo } from 'react';
import styled from 'styled-components';
import { useField, useFormikContext } from 'formik';
import { FiltersNameEnum } from '@blocs.filter';
import { FilterData, FilterValues } from '../../../shared/types';
import { StyledCheckbox } from '../../../shared/styles';

const Wrapper = styled.div<{ $filterBasicView: boolean }>`
  background-color: ${(props): string =>
    props.$filterBasicView ? props.theme.form.backgroundColor : props.theme.colors.accent.ltGrey2};
  border: 0.0625px solid ${(props): string => props.theme.colors.primary.ltGrey1};
  border-radius: 0.25rem;
  position: relative;

  ${(props) =>
    props.$filterBasicView
      ? `
    font-size: .875rem;
    font-weight: 500;
    padding: 0.4375rem 1rem;
  `
      : `
    padding: 1rem;
    min-height: 3.375rem;
  `}

  ${StyledCheckbox} {
    margin: 0;
    font-size: inherit;
  }
`;

type Props = {
  filterBasicView?: boolean;
  roleFilters: FilterValues;
  label: FilterData['label'];
  initialFilters: FilterValues;
  error?: string;
};

const AutofillByRoleCriteria: FC<Props> = ({ filterBasicView = false, label, roleFilters, initialFilters, error }) => {
  const { setValues } = useFormikContext();
  const [field] = useField(FiltersNameEnum.autofillByRoleCriteria);

  const autofillByRoleCriteria = field.value;

  const toggleAutoFillByRoleCriteria = useCallback((): void => {
    if (!autofillByRoleCriteria) {
      setValues(roleFilters);
    } else {
      setValues(initialFilters);
    }
  }, [autofillByRoleCriteria, initialFilters, roleFilters, setValues]);

  return (
    <Wrapper $filterBasicView={filterBasicView}>
      <StyledCheckbox
        {...field}
        data-qa-id="autoFillByRoleCriteria"
        isChecked={field.value}
        disabled={!roleFilters || !!error}
        checkmarkSize={filterBasicView ? 'small' : 'large'}
        label={error ? `Error: ${label}` : label}
        onChange={(): void => {
          toggleAutoFillByRoleCriteria();
        }}
      />
    </Wrapper>
  );
};

export default memo(AutofillByRoleCriteria);
